function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isObject } from './isObject';
import { isNode } from './isNode';
var METHODS = ['PUT', 'POST', 'PATCH', 'DELETE'];
var PRE_TARGETS = ['develop', 'stage'];
export var getCookie = function getCookie(credentials) {
  if (isObject(credentials)) {
    return credentials.cookie || null;
  }
  return credentials || null;
};
export var getBearer = function getBearer(credentials) {
  if (isObject(credentials)) {
    return credentials.token || null;
  }
  return null;
};
export var resource = function resource(ver, path) {
  var env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var res = path.charAt(0) === '/' ? path.substr(1) : path;
  if (ver === 'login') {
    return "https://".concat(process.env.FINECT_LOGIN_BASEURL, "/").concat(res);
  }
  var isPre = PRE_TARGETS.includes(process.env.FINECT_TARGET);
  var base = process.env.FINECT_API_BASEURL || 'api.finect.com';
  return "https://".concat(!['worker'].includes(env) && isNode() && !isPre && !base.startsWith('prod-') ? 'prod-' : '').concat(isPre ? 'stage-' : '').concat(base, "/").concat(ver, "/").concat(res);
};
var checkResponse = function checkResponse(response) {
  var contentType = response.headers.get('content-type');
  if (response.status === 302) {
    return response.json();
  }
  if (response.ok) {
    if (response.status === 204) {
      return Promise.resolve({
        code: 204
      });
    }
    if (contentType && !contentType.includes('application/json')) {
      throw new Error("Content-Type: ".concat(contentType, " not supported"));
    }
    return response.json();
  }
  var error = {
    status: response.status,
    message: response.statusText,
    response: response
  };
  if (contentType.includes('text/plain') || contentType.includes('text/html')) {
    return response.text().then(function (parsedResponse) {
      error.content = parsedResponse;
      return Promise.reject(error);
    });
  }
  if (contentType.includes('application/json')) {
    return response.json().then(function (parsedResponse) {
      Object.assign({}, error, parsedResponse);
      return Promise.reject(error);
    });
  }
  return Promise.reject(error);
};
export var getOptions = function getOptions(params) {
  var method = params.method,
    body = params.body,
    requestKey = params.key,
    requestHeaders = params.headers,
    _params$referrerPolic = params.referrerPolicy,
    referrerPolicy = _params$referrerPolic === void 0 ? null : _params$referrerPolic,
    credentials = params.credentials,
    _params$redirect = params.redirect,
    redirect = _params$redirect === void 0 ? 'follow' : _params$redirect,
    _params$cache = params.cache,
    cache = _params$cache === void 0 ? 'default' : _params$cache;
  var headers = new Headers(requestHeaders || {});
  var bearer = getBearer(credentials);
  if (bearer) {
    headers.append('authorization', "Bearer ".concat(bearer));
  }
  headers.append('key', "".concat(requestKey ? requestKey : process.env.FINECT_API_KEY));
  if (body && !(body instanceof FormData) && METHODS.includes(method)) {
    headers.append('Content-Type', 'application/json');
  }
  if (body && body instanceof FormData && METHODS.includes(method)) {}
  var cookie = getCookie(credentials);
  if (cookie) headers.append('cookie', cookie);
  headers.append('Accept', 'application/json');
  if (['no-cache'].includes(cache)) {
    headers.append('cache-control', 'no-cache');
  }
  var opts = _objectSpread({
    method: method,
    headers: headers,
    credentials: bearer ? 'omit' : ['omit'].includes(credentials) ? credentials : 'include',
    body: body && !(body instanceof FormData) ? JSON.stringify(body) : body || null,
    redirect: redirect
  }, referrerPolicy ? {
    referrerPolicy: referrerPolicy
  } : {});
  return opts;
};
export var finectAPI = function finectAPI(params) {
  var version = params.version,
    path = params.path,
    onSuccess = params.onSuccess,
    onError = params.onError,
    env = params.env;
  var endpoint = resource(version, path, env);
  var options = getOptions(params);
  return fetch(endpoint, options).then(checkResponse).then(function (response) {
    if (onSuccess) {
      try {
        return onSuccess(response);
      } catch (error) {
        throw error;
      }
    }
  }).catch(function (err) {
    err.finect_error = {
      endpoint: endpoint
    };
    if (err && err.status && onError) {
      return onError(err);
    }
    throw err;
  });
};